class SellingPlanPrice extends HTMLElement {
  connectedCallback() {
    try {
      this.moneyFormat = (this.getAttribute('data-money-format') || '').trim();
      this.symbol = this._extractSymbol(this.moneyFormat);
      this.priceRootSelector = this.getAttribute('data-price-root') || '.product-pricing';
      this.currentSel = this.getAttribute('data-price-current') || '.price-current';
      this.compareSel = this.getAttribute('data-price-compare') || '.price-compare';
      this.badgeSel = this.getAttribute('data-price-badge') || '.price-badge';

      this.updateFromCurrentSelection();
      this._attachListeners();
    } catch (e) {
      console.warn('[SellingPlanPrice] init error', e);
    }
  }

  disconnectedCallback() {
    if (this._listeners) {
      this._listeners.forEach(({ el, fn }) => el.removeEventListener('change', fn));
      this._listeners = [];
    }
  }

  _extractSymbol(format) {
    if (!format) return '$';
    const trimmed = format.trim();
    const last = trimmed.substring(trimmed.length - 1);
    if (last !== '}' && last.length > 0) return last;
    return trimmed.substring(0, 1);
  }

  _format(amount) {
    try {
      return `${this.symbol}${Number(amount).toFixed(2)}`;
    } catch {
      return `${this.symbol}${amount}`;
    }
  }

  _getPriceEls() {
    const root = document.querySelector(this.priceRootSelector) || document;
    return {
      currentEl: root.querySelector(this.currentSel),
      compareEl: root.querySelector(this.compareSel),
      badgeEl: root.querySelector(this.badgeSel),
    };
  }

  _sectionRoot() {
    const controls = document.querySelector('.sub-controls');
    if (!controls) return document;
    const sectionId = controls.getAttribute('data-section');
    const sec = controls.closest('.section-' + sectionId);
    return sec || document;
  }

  _parseSubVariants() {
    const root = this._sectionRoot();
    let el = root.querySelector('.sub-variants');
    if (!el) el = document.querySelector('.sub-variants');
    if (!el) return [];
    try {
      const raw = (el.textContent || '').trim().replace(/<!--[\s\S]*?-->/g, '').replace(/\u00A0/g, ' ');
      const data = JSON.parse(raw);
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  }

  _getForm() {
    const root = this._sectionRoot();
    return (
      root.querySelector('form[action*="/cart/add"]') ||
      root.querySelector('form') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  _norm(s) {
    return String(s || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  _getState() {
    const root = this._sectionRoot();
    const form = this._getForm();
    const variantId = form && form.querySelector('input[name="id"]') ? String(form.querySelector('input[name="id"]').value) : null;
    const sellingPlanInput = form && form.querySelector('input[name="selling_plan"]');
    const sellingPlanId = sellingPlanInput && sellingPlanInput.value ? String(sellingPlanInput.value) : null;
    const subActive = !!root.querySelector('.sub-figma__card.subscribe.is-active');
    const qtyActive = root.querySelector('.vp-group[data-option-index="0"].subscription-plan .vp-option.active');
    const targetPct = qtyActive ? parseInt(qtyActive.getAttribute('data-discount-selling') || '0', 10) : null;
    const nameCandidateRaw = qtyActive ? (qtyActive.getAttribute('data-base') || qtyActive.getAttribute('data-value') || '') : '';
    const targetName = this._norm(nameCandidateRaw.indexOf('-') !== -1 ? nameCandidateRaw.split('-')[0] : nameCandidateRaw);
    return { root, form, variantId, sellingPlanId, subActive, targetPct, targetName };
  }

  _computeFromSelection() {
    const data = this._parseSubVariants();
    const { variantId, sellingPlanId, subActive, targetPct, targetName } = this._getState();
    if (!variantId) return null;
    const v = data.find((x) => String(x.id) === String(variantId));
    if (!v) return null;

    const original = Number(v.price || 0) / 100;
    if (!subActive) {
      return { discounted: original, original };
    }

    // Find allocation by selling_plan_id first
    let alloc = null;
    if (sellingPlanId) {
      alloc = (v.allocations || []).find((a) => String(a.selling_plan_id) === String(sellingPlanId));
    }
    // Fallback: by name + discount
    if (!alloc && Array.isArray(v.allocations)) {
      const tPct = isNaN(targetPct) ? null : Number(targetPct);
      const tName = targetName;
      const norm = (s) => this._norm(s);
      const nameMatches = (a) => {
        if (!tName) return true;
        const n = norm(a.name_selling);
        return n === tName || n.includes(tName) || tName.includes(n);
      };
      const pctMatches = (a) => (tPct === null ? true : Number(a.discount) === tPct);
      alloc = v.allocations.find((a) => nameMatches(a) && pctMatches(a)) ||
              v.allocations.find((a) => tName && nameMatches(a)) ||
              v.allocations.find((a) => tPct !== null && pctMatches(a)) ||
              v.allocations[0];
    }

    if (!alloc) return { discounted: original, original };
    const discounted = Number(alloc.price || 0) / 100;
    return { discounted, original };
  }

  updateFromCurrentSelection() {
    const computed = this._computeFromSelection();
    if (computed) this._render(computed);
  }

  _render({ discounted, original }) {
    const isSubscribeActive = !!document.querySelector('.sub-figma__card.subscribe.is-active');
    if(isSubscribeActive){
      try { console.debug('[SellingPlanPrice] render', { discounted, original }); } catch(e){}
      const { currentEl, compareEl, badgeEl } = this._getPriceEls();
      if (currentEl) currentEl.textContent = this._format(discounted);
      if (compareEl) compareEl.textContent = this._format(original);
      if (badgeEl && original > 0) {
        const pct = Math.round(((original - discounted) / original) * 100);
        if (pct > 0) {
          badgeEl.textContent = `${pct}% OFF`;
          badgeEl.style.display = '';
        } else {  
          badgeEl.style.display = 'none';
        }
      }
    }

  }

  _attachListeners() {
    this._listeners = [];

    const picker = document.querySelector('variant-picker');
    if (picker) {
      const fn = () => this.updateFromCurrentSelection();
      picker.addEventListener('variant-change', fn);
      this._listeners.push({ el: picker, fn });
    }

    const root = this._sectionRoot();
    const events = ['click', 'change']; 
    const targets = [
      ...root.querySelectorAll('.vp-group[data-option-index="0"].subscription-plan .vp-option'),
      ...root.querySelectorAll('input[name="purchase_option"]'),
      ...root.querySelectorAll('.sub-figma__card'),
    ];
    targets.forEach((el) => {
      events.forEach((ev) => {
        const fn = () => this.updateFromCurrentSelection();
        el.addEventListener(ev, fn);
        this._listeners.push({ el, fn });
      });
    });

    const form = this._getForm();
    const sp = form && form.querySelector('input[name="selling_plan"]');
    if (sp) {
      const obs = new MutationObserver(() => this.updateFromCurrentSelection());
      obs.observe(sp, { attributes: true, attributeFilter: ['value'] });
      this._listeners.push({ el: { removeEventListener: () => obs.disconnect() }, fn: null });
    }

    const onPriceEvt = (e) => {
      const d = e && e.detail;
      if (!d) return;
      try { console.debug('[SellingPlanPrice] event subscription-price-change', d); } catch(e){}
      const payload = { discounted: Number(d.discounted), original: Number(d.original) };
      this._render(payload);
    };
    document.addEventListener('subscription-price-change', onPriceEvt);
    this._listeners.push({ el: document, fn: onPriceEvt });
  }
}

customElements.define('selling-plan-price', SellingPlanPrice);
